import PerfectScrollbar from 'perfect-scrollbar';

const sidebar = document.querySelector('.sidebar-nav');
if (sidebar) {
    new PerfectScrollbar(sidebar, {
        suppressScrollX: true,
    });
}
